import React from 'react';
import PropTypes from 'prop-types';
import ConnectionProfiles from "./c/ConnectionProfiles";

const LIST_OF_PROFILES = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  map: PropTypes.shape({
    transformedFileType: PropTypes.string
  })
}));

const emptySftpProfile = {
  profileId: '',
  directoryPath: '',
  fileKeyString:''
};

class ManageConnectionProfiles extends React.Component {
  constructor(props) {
    super(props);
    const { sftpProfiles: [{profileId, directoryPath, fileKeyString}] } = props.connection;
    this.state = {
      isRemoveIconDisabled: true,
      sftpProfiles: [{
        profileId,
        directoryPath,
        fileKeyString
      }]
    };
  }

  componentDidMount = () => this.props.profilesActions.fetchProfileList();

  handleProfileChange = (newProfile, index) => {
    const newSftpProfiles  = this.state.sftpProfiles.map((profile, newIndex) => {
      if (index !== newIndex) return { ...profile };
      return { ...newProfile };
    });
    this.setState({ sftpProfiles: [ ...newSftpProfiles ]});
    this.props.onProfileChange(newSftpProfiles);
  }

  handleAddProfile = () => {
    let sftpProfiles;
    this.setState(oldState => {
      sftpProfiles = [...oldState.sftpProfiles];
      return ({
        sftpProfiles: []
      });
    }, () => {
      this.setState({ sftpProfiles: [ ...sftpProfiles, emptySftpProfile]  },
        () => {
          this.setState({ isRemoveIconDisabled: (this.state.sftpProfiles.length <= 1) });
          this.props.onProfileChange(this.state.sftpProfiles);
        });
    });
  };

  handleRemoveProfile = (index) => {
    const newSftpProfiles = [...this.state.sftpProfiles];
    newSftpProfiles.splice(index, 1);
    this.setState(({
      sftpProfiles: []
    }), () => {
      this.setState(({ 
        sftpProfiles: [...newSftpProfiles] 
      }), () => {
        this.setState({ isRemoveIconDisabled: (this.state.sftpProfiles.length <= 1) });
        this.props.onProfileChange(this.state.sftpProfiles);
      });
    });
  }

  render() {
    const { isRemoveIconDisabled, sftpProfiles } = this.state;
    const { profilesList, fetchingProfileList } = this.props;
    return (
      <div>
        {
          sftpProfiles.map((profile, index) => (
            <ConnectionProfiles
              key={ index }
              sftpProfile={ profile }
              isRemoveIconDisabled={ isRemoveIconDisabled }
              showAddIcon={ (index + 1) === sftpProfiles.length }
              profilesList={ profilesList }
              fetchingProfileList={ fetchingProfileList }
              onAddConnectionProfile={ this.handleAddProfile }
              onRemoveConnectionProfile={ () => this.handleRemoveProfile(index) }
              onProfileChange={ newProfile => this.handleProfileChange(newProfile, index) }
            />
          ))
        }
      </div>
    );
  }

}

ManageConnectionProfiles.propTypes = {
  connection: PropTypes.object.isRequired,
  fetchingProfileList: PropTypes.bool,
  onProfileChange: PropTypes.func.isRequired,
  profilesList: LIST_OF_PROFILES.isRequired,
  profilesActions: PropTypes.shape({
    fetchProfileList: PropTypes.func.isRequired,
  }).isRequired
};

ManageConnectionProfiles.defaultProps = {
  fetchingProfileList: false
};

export default ManageConnectionProfiles;



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditor/ManageConnectionProfiles.js